import { render, staticRenderFns } from "./QuotationExtraModuleTable.vue?vue&type=template&id=0d42be53&"
import script from "./QuotationExtraModuleTable.vue?vue&type=script&lang=js&"
export * from "./QuotationExtraModuleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports